import { render, staticRenderFns } from "./ScrollNotice.vue?vue&type=template&id=64c6e7fc&scoped=true"
import script from "./ScrollNotice.vue?vue&type=script&lang=js"
export * from "./ScrollNotice.vue?vue&type=script&lang=js"
import style0 from "./ScrollNotice.vue?vue&type=style&index=0&id=64c6e7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6e7fc",
  null
  
)

export default component.exports